// ============================================================
// 🎭 Character Sprite System — 战斗精灵动画模型
// ============================================================
// 每个职业有 7 种战斗姿态，通过 CSS class 切换实现流畅动画
// 精灵规格: 120×160 PNG，透明背景，2.5头身 Q版比例

export const SPRITE_ACTIONS = [
  'idle',     // 待机 — 呼吸微动
  'attack',   // 普攻 — 武器挥砍
  'skill',    // 技能 — 蓄力爆发
  'hit',      // 受击 — 后仰/击退
  'defend',   // 防御 — 架招格挡
  'victory',  // 胜利 — 举剑/欢呼
  'defeated', // 败北 — 跪地/倒地
];

// 动作持续时间 (ms)
export const SPRITE_DURATION = {
  idle: 0,        // 无限
  attack: 500,
  skill: 800,
  hit: 400,
  defend: 400,
  victory: 2000,
  defeated: 1500,
};

// 动作对应的 CSS 动画效果
export const SPRITE_EFFECTS = {
  attack: 'sprite-lunge',       // 前冲
  skill: 'sprite-powerup',      // 蓄力发光
  hit: 'sprite-knockback',      // 击退
  defend: 'sprite-steady',      // 稳固
  victory: 'sprite-bounce',     // 弹跳
  defeated: 'sprite-fall',      // 倒地
};

// 8 职业精灵映射
// 图片路径: assets/sprites/{class}_{action}.png
// 生成后自动填充，无图片时 fallback 到 idle
export const SPRITE_MAP = {
  sword: {
    idle: 'assets/sprites/sword_idle.png',
    attack: 'assets/sprites/sword_attack.png',
    skill: 'assets/sprites/sword_skill.png',
    hit: 'assets/sprites/sword_hit.png',
    defend: 'assets/sprites/sword_defend.png',
    victory: 'assets/sprites/sword_victory.png',
    defeated: 'assets/sprites/sword_defeated.png',
  },
  berserk: {
    idle: 'assets/sprites/berserk_idle.png',
    attack: 'assets/sprites/berserk_attack.png',
    skill: 'assets/sprites/berserk_skill.png',
    hit: 'assets/sprites/berserk_hit.png',
    defend: 'assets/sprites/berserk_defend.png',
    victory: 'assets/sprites/berserk_victory.png',
    defeated: 'assets/sprites/berserk_defeated.png',
  },
  ghost: {
    idle: 'assets/sprites/ghost_idle.png',
    attack: 'assets/sprites/ghost_attack.png',
    skill: 'assets/sprites/ghost_skill.png',
    hit: 'assets/sprites/ghost_hit.png',
    defend: 'assets/sprites/ghost_defend.png',
    victory: 'assets/sprites/ghost_victory.png',
    defeated: 'assets/sprites/ghost_defeated.png',
  },
  soulbender: { // alias for ghost
    idle: 'assets/sprites/ghost_idle.png',
    attack: 'assets/sprites/ghost_attack.png',
    skill: 'assets/sprites/ghost_skill.png',
    hit: 'assets/sprites/ghost_hit.png',
    defend: 'assets/sprites/ghost_defend.png',
    victory: 'assets/sprites/ghost_victory.png',
    defeated: 'assets/sprites/ghost_defeated.png',
  },
  asura: {
    idle: 'assets/sprites/asura_idle.png',
    attack: 'assets/sprites/asura_attack.png',
    skill: 'assets/sprites/asura_skill.png',
    hit: 'assets/sprites/asura_hit.png',
    defend: 'assets/sprites/asura_defend.png',
    victory: 'assets/sprites/asura_victory.png',
    defeated: 'assets/sprites/asura_defeated.png',
  },
  blademaster: { // alias for sword
    idle: 'assets/sprites/sword_idle.png',
    attack: 'assets/sprites/sword_attack.png',
    skill: 'assets/sprites/sword_skill.png',
    hit: 'assets/sprites/sword_hit.png',
    defend: 'assets/sprites/sword_defend.png',
    victory: 'assets/sprites/sword_victory.png',
    defeated: 'assets/sprites/sword_defeated.png',
  },
  ranger: {
    idle: 'assets/sprites/ranger_idle.png',
    attack: 'assets/sprites/ranger_attack.png',
    skill: 'assets/sprites/ranger_skill.png',
    hit: 'assets/sprites/ranger_hit.png',
    defend: 'assets/sprites/ranger_defend.png',
    victory: 'assets/sprites/ranger_victory.png',
    defeated: 'assets/sprites/ranger_defeated.png',
  },
  launcher: {
    idle: 'assets/sprites/launcher_idle.png',
    attack: 'assets/sprites/launcher_attack.png',
    skill: 'assets/sprites/launcher_skill.png',
    hit: 'assets/sprites/launcher_hit.png',
    defend: 'assets/sprites/launcher_defend.png',
    victory: 'assets/sprites/launcher_victory.png',
    defeated: 'assets/sprites/launcher_defeated.png',
  },
  crusader: {
    idle: 'assets/sprites/crusader_idle.png',
    attack: 'assets/sprites/crusader_attack.png',
    skill: 'assets/sprites/crusader_skill.png',
    hit: 'assets/sprites/crusader_hit.png',
    defend: 'assets/sprites/crusader_defend.png',
    victory: 'assets/sprites/crusader_victory.png',
    defeated: 'assets/sprites/crusader_defeated.png',
  },
  monk: {
    idle: 'assets/sprites/monk_idle.png',
    attack: 'assets/sprites/monk_attack.png',
    skill: 'assets/sprites/monk_skill.png',
    hit: 'assets/sprites/monk_hit.png',
    defend: 'assets/sprites/monk_defend.png',
    victory: 'assets/sprites/monk_victory.png',
    defeated: 'assets/sprites/monk_defeated.png',
  },
};

// 获取精灵图（带 fallback）
export function getSprite(clsId, action) {
  const map = SPRITE_MAP[clsId];
  if (!map) return null;
  const path = map[action] || map.idle;
  // 返回路径，加载失败时 combat 渲染会 fallback 到 idle
  return path || map.idle;
}

// 预加载职业精灵
export function preloadSprites(clsId) {
  const map = SPRITE_MAP[clsId];
  if (!map) return;
  Object.values(map).forEach(src => {
    if (!src) return;
    const img = new Image();
    img.src = src;
  });
}
